import { render } from "./TransferUsdtForm.vue?vue&type=template&id=27fd6ce6&scoped=true&ts=true"
import script from "./TransferUsdtForm.vue?vue&type=script&lang=ts"
export * from "./TransferUsdtForm.vue?vue&type=script&lang=ts"

import "./TransferUsdtForm.vue?vue&type=style&index=0&id=27fd6ce6&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fd6ce6"]])

export default __exports__